// ABOUTME: Icon component for chevron up arrow used in accordion toggles
// ABOUTME: Supports className, size, color customization and onClick handler

import type { MouseEventHandler } from "react"

interface IconProps {
  className?: string
  size?: number
  color?: string
  onClick?: MouseEventHandler<SVGSVGElement>
}

export const ChevronUpIcon = ({ className = "", size = 10, color = "currentColor", onClick }: IconProps) => (
  <svg
    width={size}
    height={size * 0.6}
    viewBox="0 0 10 6"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    onClick={onClick}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 5 5 1 1 5"
    />
  </svg>
)
